// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1TKpW","btn":"styles_btn__3JMje","input":"styles_input__2A-4p"};